import type { TimePickerProps } from 'antd';
import { TimePicker as AntdTimePicker, ConfigProvider } from 'antd'

export function CustomTimePicker(props: TimePickerProps) {
    return (
        <ConfigProvider
            theme={{
                token: {
                    colorIcon: '#CE7A58',
                    colorTextQuaternary: '#000000',
                    colorTextPlaceholder: 'darkgray',
                },
                components: {
                    DatePicker: {
                        colorBgContainer: '#ffffff',
                        colorBgElevated: '#ffffff',
                    },
                },
            }}
        >
            <AntdTimePicker
                {...props}
                style={{ borderRadius: '9999px', ...props.style }}
            />
        </ConfigProvider>
    )
}